import {
    WorkbenchLoader,
    IWorkbench,
    MiddlewareService,
    MobileContextMenuService,
    SurfaceService,
    IWorkbenchSettings,
    IPlatformSetting,
    WorkbenchSettings,
} from '@tencent/workbench';
import { SlideAdapter } from '@framework/workbench/editor-adpater/mobile-adapter';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { MobileContextMenuHideMiddleware } from '@framework/workbench/middleware/mobile-context-menu-middleware';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import {
    IMobileEditorAppServices,
} from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { PLATFORM_MOBILE } from '@framework/workbench/const/mobile-setting-const';

@WorkbenchSettings({ platform: PLATFORM_MOBILE })
export default abstract class BaseMobileWorkbenchLoader extends WorkbenchLoader {
    public constructor(
        protected workbench: IWorkbench,
        protected middlewareService: MiddlewareService,
        protected surfaceService: SurfaceService,
    ) {
        super();
        this.settings.set(this.createSettings());
    }

    /**
     * 初始化开始
     * 全局中间件可在此注册。构造顺序为import顺序，执行顺序为注册顺序（先注册后执行）
     * 中间件没有必要依赖顺序。
     */
    public $onInit() {
        this.initContextMenuMiddlewares();
    }

    /**
     * 初始化完毕
     */
    public async $onReady() {
        const { id } = await this.workbench.open(SlideAdapter, {
            mode: 'stack',
        });
        if (id) {
            this.surfaceService.waitForSurfaceRender(id).then(() => {
                eventBus.emit(EventKeys.ATTACH_EDITOR);
            });
        }
        // 同步pc端 emit workbench加载完成事件
        setTimeout(() => {
            eventBus.emit(EventKeys.WORKBENCH_IS_MOUNT);
        }, 0);
    }

    public $afterControllersInit() {}

    public $onWorkbenchInitError(error: any) {
        throw error;
    }

    private initContextMenuMiddlewares() {
        this.middlewareService.use(MobileContextMenuHideMiddleware, {
            on: MobileContextMenuService,
            callbackNames: ['shouldHide'],
        });
    }

    private getSlideRenderStateManager() {
        return (AppServiceProvider.getInstance().getAppServices() as IMobileEditorAppServices)
            .viewableServiceLayer.slideRenderStateManager;
    }

    /**
     * 创建workbench的settings配置，由子类实现
     * @protected
     */
    protected abstract createSettings(): IWorkbenchSettings<IPlatformSetting>;
}
